import { Offcanvas, Form, Row, Col, Button } from 'react-bootstrap';
import Select from 'react-select';
import Flatpickr from 'react-flatpickr';

/**
 * FilterProjectReportsOffcanvas - Custom Filter for Project Reports
 * 
 * Filters available:
 * - Team Member (Multi-select)
 * - Status
 * - Priority
 * - Workflow (Multi-select)
 * - Date Range
 */
const FilterProjectReportsOffcanvas = ({ 
    show, 
    onHide,
    teamMemberFilter,
    setTeamMemberFilter,
    statusFilter,
    setStatusFilter,
    priorityFilter,
    setPriorityFilter,
    workflowFilter,
    setWorkflowFilter,
    dateRangeFilter,
    setDateRangeFilter,
    teamMemberOptions,
    statusOptions,
    priorityOptions,
    workflowOptions,
    onApply,
    onClear
}) => {
    const handleReset = () => {
        setTeamMemberFilter([]);
        setStatusFilter(null);
        setPriorityFilter(null);
        setWorkflowFilter([]);
        setDateRangeFilter([null, null]);
        if (onClear) onClear();
    };

    const handleApply = () => {
        if (onApply) onApply();
        onHide();
    };

    return (
        <Offcanvas show={show} onHide={onHide} placement="end">
            <Offcanvas.Header className='px-4 py-3' closeButton>
                <Offcanvas.Title className='display-1'>Filter Reports</Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body className='px-4 py-3'>
                <Form>
                    <Row className='gy-2'>
                        {/* Team Member */}
                        <Col sm={12}>
                            <Form.Group>
                                <Form.Label>Team Member</Form.Label>
                                <Select
                                    value={teamMemberFilter}
                                    onChange={setTeamMemberFilter}
                                    options={teamMemberOptions}
                                    className="react-select-container"
                                    classNamePrefix="react-select"
                                    placeholder=""
                                    isClearable
                                    isMulti
                                />
                            </Form.Group>
                        </Col>

                        {/* Status */}
                        <Col sm={12}>
                            <Form.Group>
                                <Form.Label>Status</Form.Label>
                                <Select
                                    value={statusFilter}
                                    onChange={setStatusFilter}
                                    options={statusOptions}
                                    className="react-select-container"
                                    classNamePrefix="react-select"
                                    placeholder=""
                                    isClearable
                                />
                            </Form.Group>
                        </Col>

                        {/* Priority */}
                        <Col sm={12}>
                            <Form.Group>
                                <Form.Label>Priority</Form.Label>
                                <Select
                                    value={priorityFilter}
                                    onChange={setPriorityFilter}
                                    options={priorityOptions}
                                    className="react-select-container"
                                    classNamePrefix="react-select"
                                    placeholder=""
                                    isClearable
                                />
                            </Form.Group>
                        </Col>

                        {/* Workflow */}
                        <Col sm={12}>
                            <Form.Group>
                                <Form.Label>Workflow</Form.Label>
                                <Select
                                    value={workflowFilter}
                                    onChange={setWorkflowFilter}
                                    options={workflowOptions}
                                    className="react-select-container"
                                    classNamePrefix="react-select"
                                    placeholder=""
                                    isClearable
                                    isMulti
                                />
                            </Form.Group>
                        </Col>

                        {/* Date Range */}
                        <Col sm={12}>
                            <Form.Group>
                                <Form.Label>Date Range</Form.Label>
                                <Flatpickr
                                    value={dateRangeFilter}
                                    onChange={setDateRangeFilter}
                                    options={{
                                        mode: 'range',
                                        dateFormat: 'd M Y',
                                        maxDate: 'today',
                                        allowInput: true,
                                        disableMobile: true,
                                        enableTime: false
                                    }}
                                    className="form-control"
                                    placeholder=""
                                />
                            </Form.Group>
                        </Col>
                    </Row>
                </Form>
            </Offcanvas.Body>
            <div className="p-3 border-top">
                <div className="d-flex justify-content-between">
                    <Button variant="link" className='text-decoration-none' onClick={handleReset}>
                        Reset
                    </Button>
                    <Button variant="primary" onClick={handleApply}>
                        Apply Filters
                    </Button>
                </div>
            </div>
        </Offcanvas>
    );
};

export default FilterProjectReportsOffcanvas;
